<template>
    <b-field :label="this.label">
        <qd-taginput v-if="items"
                    v-model="selected"
                    :data="filteredItems"
                    autocomplete
                    open-on-focus
                    :field="field"
                    type="is-primary"
                    icon="magnify"
                    :class="{'tagInputDisabled' : blocked}"
                    :disabled="blocked"
                    :closable="!blocked"
                    @typing="updateSearch">
        </qd-taginput>
    </b-field>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const Parametres = createNamespacedHelpers('parametres');
const User = createNamespacedHelpers('user');

export default {
  name: 'userTagInput',
  props: {
    value: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    field: {
      type: String,
      default: 'decorator.nomPrenom',
    },
    blocked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      search: null,
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    selected: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
    filteredItems() {
      return this.items.filter((option) => {
        return !this.alreadySelected(option) && this.searchMatch(option);
      });
    },
  },
  methods: {
    updateSearch(search) {
      this.search = search;
    },
    alreadySelected(item) {
      return this.selected.map(c => c.id).includes(item.id);
    },
    searchMatch(item) {
      return this.search != null
        ? item.decorator.nomPrenom.toString()
          .toLowerCase().indexOf(this.search.toLowerCase())
          >= 0
        : true;
    },
  },
};
</script>
